/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IAnredeDisplayModel {
  anredeId?: null | string;
  localeCode?: null | string;
  name?: null | string;
}
export class AnredeDisplayModel extends BaseModel implements IAnredeDisplayModel {
  anredeId?: null | string;
  localeCode?: null | string;
  name?: null | string;
}
class BaseAnredeDisplayModelFormGroup extends FormGroup {
  private static _instance: AnredeDisplayModelFormGroup;
  
  public static get Instance(): AnredeDisplayModelFormGroup {
    this._instance = new AnredeDisplayModelFormGroup({
      anredeId: new FormControl(null),
      localeCode: new FormControl(null),
      name: new FormControl(null),
    });

    return this._instance;
  }
}


export class AnredeDisplayModelFormGroup extends BaseAnredeDisplayModelFormGroup {
  public get AnredeId(): FormControl {
    return this.controls["anredeId"] as FormControl;
  }
  public get LocaleCode(): FormControl {
    return this.controls["localeCode"] as FormControl;
  }
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  

}

export module AnredeDisplayModelForm
  {
    export class FormFields
    {
      static _anredeId: string = "anredeId";
      static _localeCode: string = "localeCode";
      static _name: string = "name";
    }
  }

